import React, { useState } from 'react';
import { Box, Container, Fade } from '@mui/material';
import LoginForm from '../components/auth/LoginForm';
import RegisterForm from '../components/auth/RegisterForm';
import PasswordResetForm from '../components/auth/PasswordResetForm';
import BotDetectionWrapper from '../components/bot/BotDetectionWrapper';

type AuthMode = 'login' | 'register' | 'reset';

const AuthPage: React.FC = () => {
    const [mode, setMode] = useState<AuthMode>('login');

    console.log('🔐 AuthPage: Component rendered with mode:', mode);

    const handleSuccess = () => {
        console.log('🔐 AuthPage: handleSuccess called, redirecting to /');
        // Redirect to dashboard or previous page
        window.location.href = '/';
    };

    const renderForm = () => {
        console.log('🔐 AuthPage: renderForm called with mode:', mode);
        switch (mode) {
            case 'login':
                console.log('🔐 AuthPage: Rendering LoginForm');
                return (
                    <LoginForm
                        onSuccess={handleSuccess}
                        onSwitchToRegister={() => setMode('register')}
                        onSwitchToReset={() => setMode('reset')}
                    />
                );
            case 'register':
                console.log('🔐 AuthPage: Rendering RegisterForm with bot detection');
                return (
                    <BotDetectionWrapper
                        onBotDetected={(result) => {
                            console.warn('🤖 Bot detected during registration:', result);
                        }}
                        onHumanVerified={() => {
                            console.log('✅ Human verified, proceeding with registration');
                        }}
                        showDetectionStatus={true}
                        recaptchaSiteKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
                    >
                        <RegisterForm
                            onSuccess={handleSuccess}
                            onSwitchToLogin={() => setMode('login')}
                        />
                    </BotDetectionWrapper>
                );
            case 'reset':
                console.log('🔐 AuthPage: Rendering PasswordResetForm');
                return (
                    <PasswordResetForm
                        onSuccess={() => setMode('login')}
                        onSwitchToLogin={() => setMode('login')}
                    />
                );
            default:
                console.log('🔐 AuthPage: Unknown mode, returning null');
                return null;
        }
    };

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    py: 4
                }}
            >
                <Fade in={true} timeout={500}>
                    <Box sx={{ width: '100%' }}>
                        {renderForm()}
                    </Box>
                </Fade>
            </Box>
        </Container>
    );
};

export default AuthPage;
